import base from './base';

var detail = require('base/product/detail');
var teasersModules = require('turnToCustom/teaser/teasersModules');

detail.updateAvailability = function updateAvailability() {
    $('body').on('product:updateAvailability', function (e, response) {
        $('div.availability', response.$productContainer)
            .data('ready-to-order', response.product.readyToOrder)
            .data('available', response.product.available);
        $('.availability-msg').removeClass('custom-error').empty().html(response.message);
        $('.preorder-status', response.$productContainer).empty().html(response.preOrderStatus);
        $('.product-detail__imgbadges', response.$productContainer).empty().html(response.badges);
        $('.product-detail__salebadges', response.$productContainer).empty().html(response.saleBadges);
        if ($('.global-availability').length) {
            var allAvailable = $('.product-availability').toArray()
                .every(function (item) { return $(item).data('available'); });

            var allReady = $('.product-availability').toArray()
                .every(function (item) { return $(item).data('ready-to-order'); });

            $('.global-availability')
                .data('ready-to-order', allReady)
                .data('available', allAvailable);

            $('.global-availability .availability-msg').empty()
                .html(allReady ? response.message : response.resources.info_selectforstock);
        }
    });
};

detail.updateAttribute = function updateAttribute() {
    $('body').on('product:afterAttributeSelect', function (e, response) {
        if ($('.product-detail>.bundle-items').length) {
            response.container.data('pid', response.data.product.id);
            response.container.find('.product-id').text(response.data.product.id);
        } else if ($('.product-set-detail').eq(0)) {
            response.container.data('pid', response.data.product.id);
            response.container.find('.product-id').text(response.data.product.id);
        } else {
            $('.product-id').text(response.data.product.id);
            $('.product-detail:not(".bundle-item")').data('pid', response.data.product.id);
        }
        // TurnTo Integration
        TurnToCmd('set', { sku: response.data.product.id }); // eslint-disable-line new-cap
        teasersModules.loadTeaserCounts(response.data.product.id);
        // TurnToCmd('gallery.set', { skus: [response.data.product.id] });
    });
};

detail.cyberSourceUpdateAddToCart = function cyberSourceUpdateAddToCart() {
    $('body').on('product:updateAddToCart', function (e, response) {
        if (response.product.readyToOrder) {
            var applePayButton = $('.apple-pay-pdp', response.$productContainer);
            if (applePayButton.length !== 0) {
                applePayButton.attr('sku', response.product.id);
            } else {
                if ($('.apple-pay-pdp').length === 0) { // eslint-disable-line no-lonely-if
                    $('.cart-and-ipay').append('<isapplepay class="apple-pay-pdp btn"'
                        + 'sku=' + response.product.id + '></isapplepay>');
                }
            }
        } else {
            $('.apple-pay-pdp').remove();
        }
    });
};

detail.createCookieFindingMethod = function createCookieFindingMethod() {
    cookieSet.delete('finding_method');
};

export default {
    ...detail,
    ...base
};
